<script setup lang="ts"></script>

<template>
  <div class="">
    <header>Header</header>
    <slot />
  </div>
</template>
